;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { FaRegFilePdf, FaRegFileWord, FaRegFileAlt } from 'react-icons/fa';

function getFileIcon(options?: { className?: string; size?: number; color?: string }, fileName?: string | null) {
  const name = fileName ?? '';
  const extension = name.substring(name.lastIndexOf('.'));
  const size = options?.size || undefined;
  const className = options?.className || '';
  const color = options?.color || undefined;
  switch (extension.toLowerCase()) {
    case '.pdf':
      return <FaRegFilePdf className={className} size={size} color={color} />;
    case '.doc':
    case '.docx':
      return <FaRegFileWord className={className} size={size} color={color} />;
    default:
      return <FaRegFileAlt className={className} size={size} color={color} />;
  }
}

export default getFileIcon;
